<script lang="ts">
	import type { CardItem } from "./ArticleCardProps.js";
	import ArticleCard from "./ArticleCard.svelte";

	export let cards: CardItem[];
</script>

<div class="border-lttertiary border-t">
	<div class="mx-auto max-w-[104rem]">
		<div
			class="border-lttertiary mx-4 grid grid-cols-1 border-l md:mx-12 md:grid-cols-2 xl:mx-0 xl:grid-cols-[repeat(3,minmax(0,34.67rem))] xl:justify-center xl:border-l-0"
		>
			{#each cards as card}
				<div class="border-lttertiary h-full xl:-ml-px xl:h-auto xl:self-start xl:border-l first:xl:ml-0">
					<ArticleCard {card} />
				</div>
			{/each}
		</div>
	</div>
</div>
